package utils

import kotlin.math.floor

fun formatTime(seconds: Double): String {
    val m = floor(seconds / 60).toInt()
    val s = floor(seconds % 60).toInt()
    val ms = floor((seconds % 1) * 100).toInt()
    return "$m:${s.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}"
}
